import { render, staticRenderFns } from "./loading_spinner.vue?vue&type=template&id=04941f58&scoped=true&lang=html&"
var script = {}
import style0 from "./loading_spinner.vue?vue&type=style&index=0&id=04941f58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04941f58",
  null
  
)

export default component.exports